import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { authenticateUserSSO } from "../../utils/samlConfigUtils"
import { useEffect, useRef, useState } from "react"
import { isAuthenticated, validateChecksum } from "../../store/actions/CommonActions"
import { useDispatch, useSelector } from "react-redux"
import { setSelectedApplication } from "../../store/reducers/CommonReducer"
import { LINKS, OXE_LOGIN, WHATS_NEW } from "../../utils/Constants"

const ProtectedRoutes = (props) => {

    const location = useLocation()
    const navigate = useNavigate()
    const [authState, setAuthState] = useState(false) //Change to false for enabling auth

    const oxeAuthStatus = useSelector((state) => state.oxe.oxeAuthStatus)
    const hasRun = useRef(false)

    const dispatch = useDispatch()

    const app = location.pathname.replace("/", "")

    const query = new URLSearchParams(location.search)

    const payload = {
        v: query.get("V"),
        urlparams: query.get("UMC")
    }

    if (!hasRun.current && app) { // Set selected App based on the path
        if((app === LINKS || app === WHATS_NEW || app === OXE_LOGIN) || (oxeAuthStatus)) {
            dispatch(setSelectedApplication(app))
            hasRun.current = true
        } else {
            navigate("/")
        }
    }

    useEffect(() => {
        validateChecksum(payload, (validateResp) => {
            const validityStatus = validateResp?.status?.toString()
            if (validityStatus === "200") { // Checksum validation

                isAuthenticated((status) => { // Check for UMC level session [indirectly SSO authentication validation]
                    if (status === true) {
                        setAuthState(true)
                    } else if (status === false) {
                        // isTokenExpired(getSessionItem(TOKEN_1)) ? authenticateUserSSO(validateResp?.data?.ccproductid, validateResp?.data?.usertype) : clearSession()
                        authenticateUserSSO()
                    }
                })
            } else {
                navigate("/unauthorized")
            }
        })
    })

    useEffect(() => {
        if (authState && location.search)
            navigate(location.pathname === "/" ? `/${OXE_LOGIN}` : location.pathname, { replace: true })
    }, [authState, location, navigate])

    return authState && <Outlet />
}

export default ProtectedRoutes
